import { render } from "./IconWeightMeasurement.vue?vue&type=template&id=6d9963cf"
import script from "./IconWeightMeasurement.vue?vue&type=script&lang=ts"
export * from "./IconWeightMeasurement.vue?vue&type=script&lang=ts"
script.render = render

export default script